export const WatchBackground = () => (
  <div className="fixed top-0 z-[-1] h-screen w-screen overflow-y-auto overflow-x-hidden bg-[url('https://images.angelstudios.com/image/upload/q_auto:eco/v1689354516/angel-app/assets/discover/background_blur_v2.webp')] bg-cover" />
)
